module.exports = __webpack_public_path__ + "assets/GoldSigma.a8822494f0bf438d5efb43a17a164561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldSigma.png
// module id = 774
// module chunks = 0